import React from 'react';
import SEO from '../../components/common/SEO';
import Button from '../../components/common/Button';
import { aboutData } from '../../data/about';
import './About.css';

const About = () => {
  return (
    <>
      <SEO
        title="About Kirstie Warburton | Reiki Master & Holistic Healer Sydney"
        description="Meet Kirstie Warburton, Sydney's experienced Reiki Master Teacher and holistic health practitioner. Dedicated to helping you transform through Reiki healing, meditation, soul coaching and spiritual guidance."
        url="/about"
        keywords="kirstie warburton, reiki master sydney, holistic health practitioner sydney, energy healer, meditation teacher, soul coaching practitioner, spiritual guide sydney, about ko holistic health"
        breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'About', path: '/about' }]}
      />

      <div className="about-page">
        <section className="about-hero">
          <div className="container">
            <h1>{aboutData.welcomeMessage.title}</h1>
            <p className="about-hero__lead">{aboutData.welcomeMessage.content}</p>
          </div>
        </section>

        <section className="section about-story">
          <div className="container">
            <div className="about-story__content">
              <div className="about-story__text">
                <h2>{aboutData.personalStory.title}</h2>
                {aboutData.personalStory.paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <div className="about-story__images">
                <img
                  src="/images/kirstie.jpeg"
                  alt="Kirstie Warburton - Holistic Health Practitioner & Reiki Master Teacher"
                  className="about-story__img about-story__img--1"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="section about-philosophy bg-light-beige">
          <div className="container">
            <h2 className="text-center">{aboutData.philosophy.title}</h2>
            <div className="philosophy-grid">
              {aboutData.philosophy.points.map((point, index) => (
                <div key={index} className="philosophy-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  <p>{point}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section about-qualifications">
          <div className="container">
            <div className="qualifications-content">
              <div className="qualifications-main">
                <h2>Qualifications & Training</h2>
                <p className="qualifications-intro">
                  Kirstie is committed to ongoing professional development and holds certifications in various
                  holistic healing modalities to provide you with the highest quality care.
                </p>
                <div className="qualifications-grid">
                  {aboutData.qualifications.map((qual, index) => (
                    <div key={index} className="qualification-item">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M12 14l9-5-9-5-9 5 9 5z"/>
                        <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"/>
                      </svg>
                      <h3>{qual.title}</h3>
                      {qual.organization && <p className="qual-org">{qual.organization}</p>}
                      {qual.credential && <p className="qual-cred">{qual.credential}</p>}
                    </div>
                  ))}
                </div>
              </div>

              <div className="memberships-sidebar">
                <h3>Professional Memberships</h3>
                <ul>
                  {aboutData.memberships.map((membership, index) => (
                    <li key={index}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                      </svg>
                      {membership}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="section about-cta bg-beige">
          <div className="container">
            <div className="about-cta__content text-center">
              <h2>{aboutData.callToAction.title}</h2>
              <p>{aboutData.callToAction.text}</p>
              <Button href="/contact" size="large" variant="accent">
                {aboutData.callToAction.buttonText}
              </Button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
